import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ChangeEmailDialog from '../../../components/account/detail-card/change-email-dialog'
// Actions
import { changeAccountEmail } from '../../../store/actions'

const mapStateToProps = state => {
  return {
    account: state.crm.getAccountByIdResponse,
    pending: state.crm.postChangeEmailRetrieving
  }
}

const mapDispatch = dispatch => {
  return {
    changeAccountEmail: bindActionCreators(changeAccountEmail, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatch
)(ChangeEmailDialog)
